/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ShopperExperience } from '@/scapi';

function collectRegionTypeIds(regions: ShopperExperience.schemas['Region'][] | undefined, typeIds: Set<string>): void {
    for (const region of regions ?? []) {
        for (const component of region.components ?? []) {
            typeIds.add(component.typeId);
            collectRegionTypeIds(component.regions, typeIds);
        }
    }
}

/** Collect unique component type IDs in recursive region discovery order. */
export function collectComponentTypeIds(region: ShopperExperience.schemas['Region'] | undefined): Set<string> {
    const typeIds = new Set<string>();
    if (region) collectRegionTypeIds([region], typeIds);
    return typeIds;
}
